import React from "react";
import { useTranslation } from "react-i18next";
import "../assets/css/TermsAndConditions.css";

const TermsAndConditions = () => {
  const { t } = useTranslation();

  return (
    <>
      <main className="terms-conditions">
        <section className="container">
          <h1>{t("termsAndConditions.title")}</h1>
          <p className="updated-date">{t("termsAndConditions.updatedDate")}</p>

          <p>{t("termsAndConditions.intro")}</p>

          <h2>{t("termsAndConditions.section1.title")}</h2>
          <p>{t("termsAndConditions.section1.intro")}</p>
          <ul>
            <li>
              <strong>{t("termsAndConditions.section1.tokenTitle")}</strong>{" "}
              {t("termsAndConditions.section1.tokenText")}
            </li>
            <li>
              <strong>{t("termsAndConditions.section1.formTitle")}</strong>{" "}
              {t("termsAndConditions.section1.formText")}
            </li>
            <li>
              <strong>{t("termsAndConditions.section1.ethicsTitle")}</strong>{" "}
              {t("termsAndConditions.section1.ethicsText")}
              <ul>
                <li>{t("termsAndConditions.section1.ethics1")}</li>
                <li>{t("termsAndConditions.section1.ethics2")}</li>
              </ul>
            </li>
          </ul>

          <h2>{t("termsAndConditions.section2.title")}</h2>
          <p>{t("termsAndConditions.section2.intro")}</p>
          <ul>
            <li>
              <strong>{t("termsAndConditions.section2.purposeTitle")}</strong>{" "}
              {t("termsAndConditions.section2.purposeText")}
            </li>
            <li>
              <strong>{t("termsAndConditions.section2.consentTitle")}</strong>{" "}
              {t("termsAndConditions.section2.consentText")}
            </li>
          </ul>

          <h2>{t("termsAndConditions.section3.title")}</h2>
          <p>{t("termsAndConditions.section3.intro")}</p>
          <ul>
            <li>{t("termsAndConditions.section3.point1")}</li>
            <li>{t("termsAndConditions.section3.point2")}</li>
          </ul>

          <h2>{t("termsAndConditions.section4.title")}</h2>
          <ul>
            <li>
              <strong>{t("termsAndConditions.section4.cookiesTitle")}</strong>{" "}
              {t("termsAndConditions.section4.cookiesText")}
            </li>
            <li>
              <strong>{t("termsAndConditions.section4.linksTitle")}</strong>{" "}
              {t("termsAndConditions.section4.linksText")}
            </li>
          </ul>

          <h2>{t("termsAndConditions.section5.title")}</h2>
          <p>{t("termsAndConditions.section5.text")}</p>

          <h2>{t("termsAndConditions.section6.title")}</h2>
          <p>{t("termsAndConditions.section6.intro")}</p>
          <p>
            <strong>{t("termsAndConditions.section6.companyLabel")}</strong>{" "}
            {t("termsAndConditions.section6.companyName")}
          </p>
          <p>
            <strong>{t("termsAndConditions.section6.emailLabel")}</strong>{" "}
            <a href="mailto:info@autoassure360.com">info@autoassure360.com</a>
          </p>
        </section>
      </main>
    </>
  );
};

export default TermsAndConditions;
